import numeral from 'numeral';
import 'numeral/locales/es-es';
import 'numeral/locales/it';
import { langAndRegion } from 'helpers/i18n';
import esLocale from '@fullcalendar/core/locales/es';
import enLocale from '@fullcalendar/core/locales/en-gb';
import ptLocale from '@fullcalendar/core/locales/pt';
import frLocale from '@fullcalendar/core/locales/fr';
import itLocale from '@fullcalendar/core/locales/it';
import { twoDigits } from './Utils';
/*if (['es-es'].includes(langAndRegion)) numeral.locale(langAndRegion)*/
if (['es-es'].includes(langAndRegion)) {
    numeral.locale(langAndRegion);
}
else if (['es'].includes(langAndRegion)) {
    numeral.locale(langAndRegion + '-es');
}
else if (['it-it'].includes(langAndRegion)) {
    numeral.locale('it');
}
export var getLocaleFullcalendar = function () {
    switch (langAndRegion) {
        case 'es':
            return esLocale;
            break;
        case 'en':
            return enLocale;
            break;
        case 'it':
            return itLocale;
            break;
        case 'pt':
            return ptLocale;
            break;
        case 'fr':
            return frLocale;
            break;
        default: return esLocale;
    }
};
export var toNumber = function (n) { return numeral(n).format('0,0.[00]'); };
export var toNumberDecimal = function (n) { return numeral(n).format('0,0.00'); };
export var toStringNumber = function (n) { return (n < 10 && n >= 0 && n % 1 === 0) ? "0".concat(n) : String(n); };
export var toRound = function (n) { return numeral(n).format('0,0.00'); };
export var toMoney = function (n, money) {
    if (money) {
        return "".concat(numeral(n).format('0,0.00'), " ").concat(money);
    }
    return numeral(n).format('0,0.00 $');
};
export var toMoneyDecimal = function (n, money) { return (numeral(n).format('0,0.00') + ' ' + money.toUpperCase()); };
export var round = function (n, decimals) {
    if (decimals === void 0) { decimals = 4; }
    return Number(Math.round(Number(n + 'e' + decimals)) + 'e-' + decimals);
};
export var fromMoney = function (value) {
    if (typeof value === 'string') {
        var splited = value.split(' ');
        console.log('splited: ', splited);
        return Number(splited[0]);
    }
    return value;
};
export var toPercentage = function (n) {
    return numeral(n).format('0.[00] %');
};
export var toPorciento = function (n) { return "".concat(n, "%"); };
var parseDate = function (d) {
    return typeof d === 'string' ? new Date(d) : d;
};
export var toDate = function (d) { return parseDate(d).toLocaleDateString(); };
export var toDateUTC = function (d) {
    var parsed = parseDate(d);
    return "".concat(twoDigits(parsed.getUTCDate()), "/").concat(twoDigits(parsed.getUTCMonth()), "/").concat(twoDigits(parsed.getUTCFullYear()));
};
export var toTime = function (d) { return parseDate(d).toLocaleTimeString(); };
export var toDateTime = function (d) { return parseDate(d).toLocaleString(); };



//////////////////
// WEBPACK FOOTER
// ./src/helpers/Format.ts
// module id = 18
// module chunks = 0